module.exports = __webpack_public_path__ + "static/media/video.16d8fb45.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/gazoo-racing/video.mp4
// module id = 817
// module chunks = 0